import { AccountBalance } from '@mui/icons-material';
import { Box, Divider, ListItem } from '@mui/material';
import { InfoItem, SidebarItem } from '/src/components';
import { Lender } from '/src/lib/models';

export type LenderInformationProps = {
  /**
   * Whether this component is visible
   */
  open: boolean;
  /**
   * Toggles component visibility
   * @returns void
   */
  toggleOpen: () => void;
  /**
   * Lender to display information for
   */
  lender?: Lender;
};

export const LenderInformation: React.FC<LenderInformationProps> = ({ lender, open, toggleOpen }) => (
  <SidebarItem
    title="Investor Information (YTD)"
    open={open}
    toggleOpen={toggleOpen}
    toggleTooltip="Toggles the Investor Information sidebar item"
    resolved={!!lender}
  >
    <ListItem className="pad-top-bottom-xs">
      <Box padding="16px" display="flex" alignItems="center">
        <AccountBalance className="md-icon material-icons" sx={{ width: '24px', height: '24px' }} />
      </Box>
      <Box paddingX="16px" display="flex" justifyContent="center" alignItems="start" flex={82} flexDirection="column">
        <Box component="span" className="medium">
          {lender?.name}
        </Box>
        <Box component="span">{lender?.address.street}</Box>
        <Box>
          <Box component="span">{lender?.address.city}</Box>, <Box component="span">{lender?.address.state}</Box>{' '}
          <Box component="span">{lender?.address.zip}</Box>
        </Box>
      </Box>
    </ListItem>
    {lender?.longName && (
      <>
        <Divider />
        <InfoItem title="Long Name" value={lender?.longName} smallFont />
      </>
    )}
    <Divider />
    <InfoItem title="Contact Person" value={lender?.contactPerson} smallFont />
    <Divider />
    <InfoItem title="Primary Phone" value={lender?.phone.primary} smallFont />
    {lender?.phone.secondary && <InfoItem title="Secondary Phone" value={lender?.phone.secondary} smallFont />}
    {lender?.phone.fax && <InfoItem title="Fax" value={lender?.phone.fax} smallFont />}
    <Divider />
    <InfoItem title="Email" value={lender?.email} url={`mailto:${lender?.email}`} smallFont />
    <InfoItem title="Website" value={lender?.website} url={lender?.website} smallFont />
    <Divider />
    <InfoItem title="Line of Business" value={lender?.socketLineOfBusiness ?? ''} capitalize smallFont />
    <InfoItem title="Company Type" value={lender?.companyType} smallFont />
    <Divider />
    <InfoItem title="Status" value={lender?.status ?? ''} capitalize smallFont />
  </SidebarItem>
);
